import React from 'react';
import { TableHead, TableRow, TableCell, Checkbox, TableSortLabel } from '@mui/material';
import { useStyles } from './styles';
import { useTranslation } from 'react-i18next';
import { IColumn } from '../../categoriesManagement.types';

interface CategoriesTableHeadProps {
  columns: readonly IColumn[];
  numSelected: number;
  rowCount: number;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  order: 'asc' | 'desc';
  orderBy: string;
  onRequestSort: (property: 'image' | 'foodName' | 'foodTruck' | 'price' | 'category') => void;
}

const CategoriesTableHead: React.FC<CategoriesTableHeadProps> = ({ columns, numSelected, rowCount, onSelectAllClick, order, orderBy, onRequestSort }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <TableHead>
      <TableRow className={classes.TableHeader}>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
          />
        </TableCell>
        {columns.map((column) => (
          <TableCell key={column.id} style={{ minWidth: column.minWidth }}>
            {column.sortable ? (
              <TableSortLabel active={orderBy === column.id} direction={orderBy === column.id ? order : 'asc'} onClick={() => onRequestSort(column.id)}>
                {t(column.label)}
              </TableSortLabel>
            ) : (
              t(column.label)
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default CategoriesTableHead;
